import {combineReducers} from 'redux'
import {connectRouter} from 'connected-react-router'
import {History} from 'history'
import staticReducers from './static-reducers'

const rootReducer = (history: History, asyncReducers = {}) =>
    combineReducers({
        router: connectRouter(history as History),
        ...staticReducers,
        ...asyncReducers,
    })

export default rootReducer
